import { Select } from '@warp-ds/react/components/select';
import type { ChangeEvent } from 'react';
import type { ApiQueryParams } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';

export interface SortDropdownProps {
    defaultValue: string;
    selectedValue?: string;
    sortOptions?: string[];
    changeSort: (newSortValue?: string) => void;
    triggerFetch?: (queryParam?: ApiQueryParams) => void;
}

export const SortDropdown = ({ defaultValue, selectedValue, sortOptions, changeSort, triggerFetch }: SortDropdownProps) => {
    const onChange = (event: ChangeEvent<HTMLSelectElement>): void => {
        if (event.target.value === defaultValue) {
            changeSort(undefined);
        } else {
            changeSort(event.target.value);
        }
        if (triggerFetch) triggerFetch();
    };

    return (
        <Select aria-label="Sorter på" value={selectedValue ?? defaultValue} onChange={onChange} data-testid="sortDropdown">
            {(sortOptions ?? [])
                .filter((option: string) => Boolean(displayValues.sorting[option]))
                .map((option: string) => (
                    <option key={option} value={option}>
                        {displayValues.sorting[option]}
                    </option>
                ))}
        </Select>
    );
};
